import ApiService from "../core/services/api.service";

export default {
  getReservationPartners(requestGuid, date, checkPartnerAvailabilityForReservation) {
    if (date)
      return ApiService.get(
        `admin/v1/partners/reservationPartners/${requestGuid}?reservationDateUtc=${date}&checkPartnerAvailabilityForReservation=${checkPartnerAvailabilityForReservation}`
      );
    else {
      return ApiService.get(
        `admin/v1/partners/reservationPartners/${requestGuid}?checkPartnerAvailabilityForReservation=${checkPartnerAvailabilityForReservation}`
      );
    }
  },
  getPartnerReservations(partnerGuid, date) {
    return ApiService.get(
      `admin/v1/partners/PartnerReservations/${partnerGuid}?reservationDateUtc=${date}`
    );
  },
  getPartners() {
    return ApiService.get(`admin/v1/partners`);
  },
  getPartner(partnerGuid) {
    return ApiService.get(`admin/v1/partners/${partnerGuid}`);
  },
  getSignature(guid) {
    return ApiService.getBuffer(`admin/v1/partners/signature/${guid}`);
  },
  uploadSignature(obj) {
    return ApiService.post(`admin/v1/partners/signature`,obj);
  },
  getPartnerTypes() {
    return ApiService.get(`admin/v1/partners/types`);
  },
  createPartner(obj) {
    return ApiService.post(`admin/v1/partners/create`, obj);
  },
  editPartner(obj) {
    return ApiService.post(`admin/v1/partners/edit`, obj);
  },
};
